export const handleChangeInputCourierLoginPage = (name, value) => ({
    type: 'CHANGE_INPUT_COURIER_LOGIN_PAGE', name, value
});

export const handleChangeCourierProfileData = (info) => ({
    type: 'CHANGE_COURIER_PROFILE_DATA', info
});

export const handleChangeCourierToken = (token) => ({
    type: 'CHANGE_COURIER_TOKEN', token
});

export const actionLogOutCourier = (token) => ({
    type: 'LOG_OUT_COURIER', token
});